import {  Component,  OnInit,  Input} from '@angular/core';
import {  MenuItem} from 'primeng/api/menuitem';
import {  ConfirmationService} from 'primeng/api';
import {  ManageOem} from 'src/app/models/equipments/manageoem'
import {  ModelService,  ManufacturerService,  EquipmentService,  WorktypeService,  ServicerequestService,  SqacodeService,
  PartsService,  SqasubcodeService} from 'src/app/services';
import {  SelectItem} from 'primeng/api';
import {  AccessUserInfo} from 'src/app/models';

@Component({
  selector: 'bart-manageoem-menu',
  templateUrl: './manageoem.component.html',
  styleUrls: ['./manageoem.component.scss'],
  providers: [ConfirmationService]
})
export class ManageoemComponent implements OnInit {

  ngmodelScheduleId_1: string="";
  ngmodelScheduleId_2: string="";
  showCustom: boolean = false;
  userDetail: any = null;
  errors: any[];
  items: MenuItem[];
  ManuFacturerListDataPrnt: any[];
  ModelListDataPrnt: any[];
  manageOemMoel: ManageOem;
  manageOemMoelmnf: ManageOem;
  public manufacturarsList: SelectItem[];
  public manufacturarsTypeList: SelectItem[];
  public manufacturarsSubTypeList: SelectItem[];
  public serviceRequestTypesList: SelectItem[];
  public PMScheduleForOEMList: SelectItem[];
  public EquipmentTypeSQACodesList: SelectItem[];
  public EquipmentTypeSQACodesList2: SelectItem[];
  public SqaSubCodesList: SelectItem[];
  public SqaSubCodesList2: SelectItem[];
  public ScheduleFrequencyList: SelectItem[];
  public WorkTypesList: SelectItem[];
  public ModelPartsList: SelectItem[];
  loading = false;
  setComboLabel: string;
  public versionList: SelectItem[];
  public versionList1: SelectItem[];
  public versionList2: SelectItem[];
  public versionList3: SelectItem[];
  public EquipmentWarrantyList: SelectItem[];
  public PartWarrantyList: SelectItem[];
  conformDel: boolean;
  public TypeSelected: number;
  modelAndMaintanceSave = {
    modelSaved: 0,
    maintaicheSaved: 0
  }
  mangeOemSelected = 'MODEL';
  manufacturerID: number;
  getModelsParam = {
    manufacturerId: 0
  };
  getServiceRequestTypesPram = {
    ServiceRequestTypeId: 0
  };
  getModelsParamInit = {
    manufacturerId: 0
  };
  getEquipmentSubtypesParam = {
    equipmentTypeId: 0
  }
  getModelPartsPram = {
    modelId: 0,
    searchTerm: '',
    sortColumn: 'partDescription ASC'
  }
  getScheduleFrequencyParam = {
    ScheduleTypeID: 2
  }
  getManufacturerParam = {
    manufacturerId: 0
  };
  getPMScheduleForOEMParam = {
    PMScheduleID: 0,
    isAssignableFlag: 1
  }
  getEquipmentTypeSQACodesParam = {
    //equipmentId:1
    equipmentTypeId: 0
  }
  getSqaSubCodesParam = {
    ISSQACODE: 1,
    ISSQASUBCODE: 0,
    SQASUBCODEID: null,
    SQACODEID: 0,
    SQASUBCODE: null,
    ALLCODES: null,
    ISFREQUENCYFLAG: null
  }
  getSqaSubCodesParam2 = {
    ISSQACODE: 1,
    ISSQASUBCODE: 0,
    SQASUBCODEID: null,
    SQACODEID: 0,
    SQASUBCODE: null,
    ALLCODES: null,
    ISFREQUENCYFLAG: null
  }
  GetManufacturarTypeParam = {
    IsActiveFlag: 0
  }
  getWorkTypesPram = {
    isScheduledFlag: null,
    isUnscheduledFlag: 1
  }
  addModelsParam = {
    equipmentTypeId: 0,
    equipmentSubTypeId: 0,
    manufacturerId: 0,
    ModelNumber: '',
    hasClock: 0,
    pmEvents: 0,
    disinfectionCultureEvents: 0,
    IsNickNameEnabled: 0,
    EquipmentSoftwareID: '',
    UserID: '',
    IsIpAddressEnabled: 0
  };
  InsModelScheduleParam = {
    ModelId: 0,
    PMScheduleId: 0,
    ScheduleTypeID: 0,
    ServiceRequestTypeId: 0,
    ScheduleFrequencyId: 0,
    isAlertEnabledFlag: 0,
    workTypeId: 0,
    resolutionPartId: 0,
    daysBeforeZero: 0,
    SQACodeId: 0,
    SQASubCodeId: 0,
    isScheduleActiveFlag: 0
  }
  updateEquipmentScheduleByModelParam = {
    isScheduled: 0,
    isPMScheduled: 0,
    modelId: 0
  }
  GetModelScheduleParam = {
    ModelId: 0,
    MODELSCHEDULEID: 0,
    SCHEDULETYPEID: 0,
  }
  updateModelScheduleParam = {
    ModelId: 0,
    SCHEDULETYPEID: 0,
    ServiceRequestTypeId: 0,
    ScheduleFrequencyId: 0,
    isAlertEnabledFlag: 0,
    workTypeId: 0,
    resolutionPartId: 0,
    daysBeforeZero: 0,
    SQACodeId: 0,
    SQASubCodeId: 0,
    isScheduled: 0,
    ModelScheduleID: 0
    // PMScheduleId :0 
  }
  updatePMScheduleParam = {
    PMScheduleID: 0,
    ModelId: 0
  }
  ADDMANUFACTURER = {
    manufacturerName: '',
    iProcVendorId: 0,
    warrantyDefaultEquipment: 0,
    warrantyDefaultParts: 0,
    isActiveFlag: 0,
    userId: 0
  }
  VALIDATEIPROC = {
    manufacturerid: 0,
    iprocid: 0
  }
  UPDATEMANUFACTURER = {
    manufacturerID: 0,
    manufacturerName: '',
    iProcVendorId: 0,
    warrantyDefaultEquipment: 0,
    warrantyDefaultParts: 0,
    isActiveFlag: 0,
    userId: 0
  }
  CHECKMANUFACTURER = {
    manufacturerName: '',
    manufacturerID: 0
  }
  GETMODELS = {
    manufacturerId: 0,
    equipmentTypeId: 0,
    modelId: 0,
    SearchTerm: '',
    modelsOnly: ''
  }
  UPDATEMANUFACTURERACTIVEFLAG = {
    manufacturerID: 0,
    isActiveFlag: 0
  }
  updateModelsParam = {
    modelId: 0,
    equipmentTypeId: 0,
    equipmentSubTypeId: 0,
    manufacturerId: 0,
    ModelNumber: '',
    hasClock: 0,
    pmEvents: 0,
    disinfectionCultureEvents: 0,
    IsNickNameEnabled: 0,
    EquipmentSoftwareID: '',
    IsIpAddressEnabled: 0,
    ModifiedBy: '',
  };
  CHECKMODEL = {
    modelNumber: '',
    manufacturerID: 0,
    modelId: 0
  }
  deleteModelParam = {
    ModelId: 0,
    isActiveFlag: 0
  };
  manufaturarSubTypeParam = {
    equipmenttypeid: 0
  }
  getModelScheduleParam = {
    ModelId: 0,
    MODELSCHEDULEID: 0,
    ScheduleTypeId: 0
  }
  objManageOemMenuFromList: ManageOem;
  hideAdd: boolean;
  hideAlerts: boolean;
  hideSave: boolean;
  hideDelete: boolean;
  hideCancel: boolean;
  hideSubType: boolean;
  hideSRScheduleAlerts: boolean;
  MaintancePartialHide: boolean;
  ShowAlertpopup: boolean;
  ModelPartsListEnabled: boolean;
  SQASubCodeDisabled: boolean;
  SQASubCodeDisabled2: boolean;
  dialogHeader: string;
  public ShowLodingGrid: boolean = false;
  hideAddMnfr: boolean;
  hideSaveMnfr: boolean;
  hideDeleteMnfr: boolean;
  hideCancelMnfr: boolean;
  hideCustomTab: boolean;
  hidetabPanelCustom = false;
  cols: any[];
  colsManuFacturer: any[];
  SearchData: any[];
  ManuFacturerListData: any[];
  ModelListData: any[];
  public selectedTab: string;
  @Input() TabSelected: string;
  @Input() TaChildManufacturerID: number;
  constructor(
    private _sqasubcodeService: SqasubcodeService,
    private _ManufacturerService: ManufacturerService,
    private _EquipmentService: EquipmentService,
    private _ServiceRequestService: ServicerequestService,
    private _SqacodeService: SqacodeService,
    private _WorktypeService: WorktypeService,
    private _PartsService: PartsService,
    private confirmationService: ConfirmationService,
    private _ModelService: ModelService) {
    this.manageOemMoel = {
      manufacturerID: 0,
      manufacturerName: '',
      CreatedBy: '',
      DateCreated: '',
      ModifiedBy: '',
      DateModified: '',
      isActiveFlag: null,
      equipmentTypeID: 0,
      equipmentTypeDescription: '',
      softwareVersion1: '',
      partWarrantyID: 0,
      equipmentWarrantyID: 0,
      iProcVendorId: null,
      warrantyDefaultEquipment: 30,
      warrantyDefaultParts: 30,
      userId: 0,
      ModelId: 0,
      workTypeId: 0,
      resolutionPartId: 0,
      isScheduleActiveFlag: 0,
      ScheduleTypeID1: 0,
      ServiceRequestTypeId1: 0,
      ScheduleFrequencyId1: 0,
      PMScheduleId1: 0,
      daysBeforeZero1: null,
      isAlertEnabledFlag1: 0,
      SQACodeId1: 0,
      SQASubCodeId1: 0,
      ScheduleTypeID2: 0,
      ServiceRequestTypeId2: 0,
      ScheduleFrequencyId2: 0,
      PMScheduleId2: 0,
      daysBeforeZero2: 0,
      isAlertEnabledFlag2: 0,
      SQACodeId2: 0,
      SQASubCodeId2: 0
    }
    this.manageOemMoelmnf = {
      manufacturerNameMnf: '',
      manufacturerIDMnf: 0,
      iProcVendorId: null,
      isActiveFlag: null,
      warrantyDefaultEquipment: 30,
      warrantyDefaultParts: 30,
      equipmentWarrantyID: 0,
      partWarrantyID: 0,
      userId: 0,
      CreatedBy: '',
      DateCreated: '',
      ModifiedBy: '',
      DateModified: ''
    }
    this.userDetail = AccessUserInfo.getUserInfo();
  }

  ngOnInit() {
    this.hideAdd = false;
    this.hideSave = true;
    this.hideAlerts = true;
    this.hideDelete = true;
    this.hideCancel = true;
    this.hideSubType = true;
    this.hideSRScheduleAlerts = true;
    this.MaintancePartialHide = true;
    this.hideAddMnfr = false;
    this.hideSaveMnfr = true;
    this.hideDeleteMnfr = true;
    this.ShowAlertpopup = false;
    this.ModelPartsListEnabled = true;
    this.SQASubCodeDisabled = true;
    this.SQASubCodeDisabled2 = true;
    this.hideCancelMnfr = true;
    this.hideCustomTab = true;
    this.conformDel = false;
    this.GetManufacturar();
    this.GetManufacturarType();
    this.getVersionList();
    this.getPartWarranty();
    this.getEquipmentWarranty();
    this.getServiceRequestTypes(this.getServiceRequestTypesPram);
    this.getPMScheduleForOEM(this.getPMScheduleForOEMParam);
    //this.getEquipmentTypeSQACodes(this.getEquipmentTypeSQACodesParam);
    this.getEquipmentTypeSQACodes2(this.getEquipmentTypeSQACodesParam);
    this.getScheduleFrequency(this.getScheduleFrequencyParam)
    this.cols = [{
        field: 'manufacturername',
        header: 'Manufacturer',
        display: 'table-cell'
      },
      {
        field: 'modelnumber',
        header: 'Model',
        display: 'table-cell'
      },
      {
        field: 'activeEquipCount',
        header: 'No. Active Devices',
        display: 'table-cell'
      },
      {
        field: 'otherEquipCount',
        header: 'No. Other Devices',
        display: 'table-cell'
      },
      {
        field: 'pmEvents',
        header: 'Events: PM',
        display: 'table-cell'
      },
      {
        field: 'disinfectionCultureEvents',
        header: 'Events: DC',
        display: 'table-cell'
      },
      {
        field: 'manufacturerid',
        header: 'manufacturerid',
        display: 'none'
      },
      {
        field: 'modelnumber',
        header: 'modelnumber',
        display: 'none'
      },
      {
        field: 'hasClock',
        header: 'hasClock',
        display: 'none'
      },
      {
        field: 'equipmenttypeid',
        header: 'equipmenttypeid',
        display: 'none'
      },
      {
        field: 'IsIpAddressEnabled',
        header: 'IsIpAddressEnabled',
        display: 'none'
      },
      {
        field: 'IsNickNameEnabled',
        header: 'IsNickNameEnabled',
        display: 'none'
      },
      {
        field: 'modelid',
        header: 'modelid',
        display: 'none'
      },
      {
        field: 'equipmentsubtypeid',
        header: 'equipmentsubtypeid',
        display: 'none'
      },
      {
        field: 'SoftwareVersion',
        header: 'SoftwareVersion',
        display: 'none'
      },
    ];
    this.colsManuFacturer = [{
        field: 'ManufacturerName',
        header: 'Manufacturer',
        display: 'table-cell'
      },
      {
        field: 'isActive',
        header: 'Active',
        display: 'table-cell'
      },
      {
        field: 'iProcVendorID',
        header: 'iProcID',
        display: 'table-cell'
      },
      {
        field: 'isActiveFlag',
        header: 'isActiveFlag',
        display: 'table-cell'
      },
      {
        field: 'WarrantyDefaultEquipment',
        header: 'WarrantyDefaultEquipment',
        display: 'none'
      },
      {
        field: 'WarrantyDefaultParts',
        header: 'WarrantyDefaultParts',
        display: 'none'
      },
      {
        field: 'ManufacturerID',
        header: 'ManufacturerID',
        display: 'none'
      },

    ];
    this.getManufacturers(this.getManufacturerParam);
    this.getWorkTypes(this.getWorkTypesPram);
  }
  GetManufacturar() {
    this.loading = true;
    this.setComboLabel = 'Manufacturer';
    this._ManufacturerService.getManufacturers(JSON.stringify({
        "GETMANUFACTURERS": {
          "isActiveFlag": "1"
        }
      }))
      .subscribe((allManufacturesResponse: any) => {
        if (allManufacturesResponse.manufacturers.length > 0)
          this.manufacturarsList = [];
        for (let c of allManufacturesResponse.manufacturers) {
          this.manufacturarsList.push({
            label: c.ManufacturerName,
            value: c.ManufacturerID
          });
        }
        this.loading = false;
        this.setComboLabel = '';
      }, (respose: Response) => {
        this.manufacturarsList = [];
        this.loading = false;
      });

  }
  GetManufacturarType() {
    this._EquipmentService.getEquipmentTypes()
      .subscribe((allManufacturarTypeResponse: any) => {
        if (allManufacturarTypeResponse.equipmentType.length > 0)
          this.manufacturarsTypeList = [];
        for (let c of allManufacturarTypeResponse.equipmentType) {
          this.manufacturarsTypeList.push({
            label: c.EquipmentTypeDescription,
            value: c.EquipmentTypeId
          });;
        }
      }, (respose: Response) => {
        this.manufacturarsTypeList = [];
      });

  }
  getEquipmentSubtypes(manufactureTypeID: number) {
    this.getEquipmentSubtypesParam.equipmentTypeId = manufactureTypeID;
    var GETEQUIPMENTSUBTYPES = this.getEquipmentSubtypesParam;
    this._EquipmentService.getEquipmentSubtypes(JSON.stringify({
        GETEQUIPMENTSUBTYPES
      }))
      .subscribe((allManufacturarTypeResponse: any) => {
        if (allManufacturarTypeResponse.equipmentSubType.length > 0)
          this.manufacturarsSubTypeList = [];
        for (let c of allManufacturarTypeResponse.equipmentSubType) {
          this.manufacturarsSubTypeList.push({
            label: c.EquipmentSubTypeDescription,
            value: c.EquipmentSubTypeId
          });;
        }
      }, (respose: Response) => {
        this.manufacturarsSubTypeList = [];
      });

  }
  getVersionList() {
    this.versionList = [{
        label: 'Software Version',
        value: '1'
      },
      {
        label: 'Module 1',
        value: '2'
      },
      {
        label: 'Module 2',
        value: '3'
      }
    ]
    this.versionList1 = [{
        label: 'Software Version',
        value: '1'
      },
      {
        label: 'Module 1',
        value: '2'
      },
      {
        label: 'Module 2',
        value: '3'
      }
    ]
  }
  getEquipmentWarranty() {
    this.EquipmentWarrantyList = [{
        label: '30 Days',
        value: 30
      },
      {
        label: '60 Days',
        value: 60
      },
      {
        label: '90 Days',
        value: 90
      },
      {
        label: '120 Days',
        value: 120
      },
      {
        label: '180 Days',
        value: 180
      },
      {
        label: '365 Days',
        value: 365
      }
    ]
  }
  getPartWarranty() {
    this.PartWarrantyList = [{
        label: '30 Days',
        value: 30
      },
      {
        label: '60 Days',
        value: 60
      },
      {
        label: '90 Days',
        value: 90
      },
      {
        label: '120 Days',
        value: 120
      },
      {
        label: '180 Days',
        value: 180
      },
      {
        label: '365 Days',
        value: 365
      }
    ]
  }
  getSelectedTab(event: any) {
    if (event.index == 1) {
      this.mangeOemSelected = 'MANUFACTURER';
    }
    if (event.index == 0) {
      this.mangeOemSelected = 'MODEL';
    }

  }
  LoadModels(value) {

    if (this.manageOemMoel.manufacturerID != null) {
      this.ngmodelScheduleId_1="";
      this.ngmodelScheduleId_2="";
      this.getModelsParam.manufacturerId = this.manageOemMoel.manufacturerID;
      this.getModels(this.getModelsParam);
      this.hideAdd = false;
      this.hideSave = true;
      this.hideDelete = true;
      this.hideCancel = true;
    }

  }
  LoadManufacture(value) {
    if (this.manageOemMoel.manufacturerID != null) {
      this.hideAddMnfr = false;
      this.hideSaveMnfr = true;
      this.hideDeleteMnfr = true;
      this.hideCancelMnfr = true;
    }

  }
  receiveMessage($event) {
    this.objManageOemMenuFromList = $event
    if (this.objManageOemMenuFromList.manufacturerName.length > 0) {
      this.manageOemMoel = this.objManageOemMenuFromList;
      if (this.manageOemMoel.equipmentSubTypeID != null && this.manageOemMoel.equipmentSubTypeID > 0) {
        this.hideSubType = false;
      } else {
        this.hideSubType = true;
      }
      this.hideAdd = true;
      this.hideSave = false;
      this.hideDelete = false;
      this.hideCancel = false;
      this.hideAddMnfr = true;
      this.hideSaveMnfr = false;
      this.hideDeleteMnfr = false;
      this.hideCancelMnfr = false;
    }
  }

  AddModel(event) {    
    this.ngmodelScheduleId_1="";
    this.ngmodelScheduleId_2="";
    var msg = new Array();
    var saveSuccessful: number;
    this.IsModelValid = false;
    var freqSelected_1 = this.manageOemMoel.PMScheduleId1;
    this.IsMaintanceValid = false;
    var maintSaved = new Array();
    this.errors = this.isModelVlaid();
    var errorsMaint = new Array();
    if (freqSelected_1 > 0 && freqSelected_1 != null) {
      errorsMaint = this.validateSRMaintenance(1);
      this.errors = this.errors.concat(errorsMaint);
      if (errorsMaint.length <= 0) {
        this.freqSel = 1;
      }

    }
    if (this.errors.length > 0) {
      this.dialogHeader = "Validation Error";
      this.ShowAlertpopup = true;
      return false;
    }
    if (this.errors.length <= 0) {
      this.addModelsParam.equipmentSubTypeId = this.manageOemMoel.equipmentSubTypeID;
      this.addModelsParam.equipmentTypeId = this.manageOemMoel.equipmentTypeID;
      this.addModelsParam.equipmentSubTypeId = this.manageOemMoel.equipmentSubTypeID;
      this.addModelsParam.manufacturerId = this.manageOemMoel.manufacturerID;
      this.addModelsParam.ModelNumber = this.manageOemMoel.modelName;
      this.addModelsParam.hasClock = this.manageOemMoel.HasClock;
      this.addModelsParam.pmEvents = this.manageOemMoel.pmEvents;
      this.addModelsParam.disinfectionCultureEvents = this.manageOemMoel.disinfectionCultureEvents;
      this.addModelsParam.IsNickNameEnabled = this.manageOemMoel.nicknameEnabled;
      if (this.manageOemMoel.softwareVersion1 == null) {
        this.manageOemMoel.softwareVersion1 = "0";
      }
      if (this.manageOemMoel.softwareVersion2 == null) {
        this.manageOemMoel.softwareVersion2 = "0";
      }
      if (this.manageOemMoel.softwareVersion3 == null) {
        this.manageOemMoel.softwareVersion3 = "0";
      }

      var sfoterwareVersion1 = new String(this.manageOemMoel.softwareVersion1 + '_' + this.manageOemMoel.softwareVersion1VersionNo + ',');
      var sfoterwareVersion2 = new String(this.manageOemMoel.softwareVersion2 + '_' + this.manageOemMoel.softwareVersion2VersionNo) + ',';
      var sfoterwareVersion3 = new String(this.manageOemMoel.softwareVersion3 + '_' + this.manageOemMoel.softwareVersion3VersionNo);
      var sfoterwareVersion4 = sfoterwareVersion1.concat(sfoterwareVersion2.toString()).concat(sfoterwareVersion3.toString())
      this.addModelsParam.EquipmentSoftwareID = sfoterwareVersion4.toString();
      this.addModelsParam.UserID = this.userDetail.userId;
      this.addModelsParam.IsIpAddressEnabled = this.manageOemMoel.IPAddressEnabled;
      this.CHECKMODEL.manufacturerID = this.manageOemMoel.manufacturerID;
      this.CHECKMODEL.modelId = this.manageOemMoel.modelID;
      this.CHECKMODEL.modelNumber = this.manageOemMoel.modelName;
      this.GETMODELS.modelId = 0;
      this.GETMODELS.equipmentTypeId = this.manageOemMoel.equipmentTypeID;
      this.GETMODELS.manufacturerId = this.manageOemMoel.manufacturerID;
      this.GETMODELS.modelsOnly = '';
      this.GetModelScheduleParam.ModelId = this.manageOemMoel.ModelId;
      this.InsModelScheduleParam.ServiceRequestTypeId = this.manageOemMoel.ServiceRequestTypeId1;
      this.InsModelScheduleParam.ScheduleFrequencyId = this.manageOemMoel.ScheduleFrequencyId1;
      this.InsModelScheduleParam.isAlertEnabledFlag = this.manageOemMoel.isAlertEnabledFlag1;
      this.InsModelScheduleParam.workTypeId = 1;
      this.InsModelScheduleParam.daysBeforeZero = this.manageOemMoel.daysBeforeZero1;
      this.InsModelScheduleParam.SQACodeId = this.manageOemMoel.SQACodeId1;
      this.InsModelScheduleParam.SQASubCodeId = this.manageOemMoel.SQASubCodeId1;
      if (this.addModelsParam != null) {
        var ADDMODEL = this.addModelsParam;
        var CHECKMODEL = this.CHECKMODEL;
        var GETMODELS = this.GETMODELS;
        this._ModelService.addModel(JSON.stringify({
          ADDMODEL,
          CHECKMODEL,
          GETMODELS
        })).subscribe((allModelsResponse: any) => {
          if (allModelsResponse.alreadyexists == 1) {
            msg.push('Model Name already exists');
            this.errors = [];
            this.errors = msg;
            this.dialogHeader = "Validation Error";
            this.ShowAlertpopup = true;
          } else if (allModelsResponse.addModel > 0) {
            msg.push('Model successfully added.');
            saveSuccessful = 1;
            this.modelAndMaintanceSave.modelSaved = 1;
            this.manageOemMoel.ModelId = allModelsResponse.addModel;
            this.InsModelScheduleParam.ModelId = this.manageOemMoel.ModelId;
            if (this.freqSel != 1 && saveSuccessful == 1) {
              this.errors = [];
              this.errors = msg;
              this.dialogHeader = "Save Successful";
              this.ShowAlertpopup = true;
              this.doCancelEditModel(this.manageOemMoel.manufacturerID);
            }
          } else {
            msg.push('Model Addition Failed.');
          }
          
          if (this.freqSel == 1 && saveSuccessful == 1) {
            this.doSaveSRMaintenance(1);
            if (maintSaved.length > 0) {
              msg.push("Model info has been saved.");
              msg.push("Maintenance SR Schedule / Alert has been saved.");
              saveSuccessful = 1;
            } else {
              msg += allModelsResponse.errors;
            }
          }

        }, (respose: Response) => {});
      }

    }

  }
  isModelValid: boolean;
  isModelVlaid() {
    var modelErrors = new Array();
    this.isModelValid = true;
    if (this.manageOemMoel.manufacturerID == 0) {
      this.isModelValid = false;
      modelErrors.push("Please select a manufacturer.");
    }
    if (this.manageOemMoel.modelName == "" || this.manageOemMoel.modelName == null || this.manageOemMoel.modelName === undefined) {
      this.isModelValid = false;
      modelErrors.push("Please enter a model name.");
    } else if (this.manageOemMoel.modelName.length <= 2) {
      this.isModelValid = false;
      modelErrors.push("Please enter a model name at least three characters in length.");
    }
    if (this.manageOemMoel.equipmentTypeID == 0 || this.manageOemMoel.equipmentTypeID == undefined || this.manageOemMoel.equipmentTypeID == null) {
      this.isModelValid = false;
      modelErrors.push("Please select a type.");
    }
    if (this.manageOemMoel.equipmentSubTypeID == 0 || this.manageOemMoel.equipmentSubTypeID == undefined) {
      modelErrors.push("Please select an equipment sub-type.");
    }
    if (this.manageOemMoel.HasClock == null || this.manageOemMoel.HasClock === undefined) {
      this.isModelValid = false;
      modelErrors.push("Please select if the model has a clock.");
    }
    if (this.manageOemMoel.pmEvents < 0 || this.manageOemMoel.pmEvents == null || this.manageOemMoel.pmEvents === undefined || this.manageOemMoel.pmEvents.toString() == "" ) {
      
      this.isModelValid = false;
      modelErrors.push("Please enter Events: PM.");
    } else {
      if (isNaN(this.manageOemMoel.pmEvents) == true) {
        modelErrors.push("Events: PM must be a numerical value.");
      }
    }
    //Start:Commented By Harikesh on 03-Nov-2020 for Defect#12437
    // if (this.manageOemMoel.nicknameEnabled == null || this.manageOemMoel.nicknameEnabled === undefined) {
    //   this.isModelValid = false;
    //   modelErrors.push("Please select if the model has a nickname.");
    // }

    // if (this.manageOemMoel.IPAddressEnabled == null || this.manageOemMoel.IPAddressEnabled === undefined) {
    //   this.isModelValid = false;
    //   modelErrors.push("Please select if the model has an IP address.");
    // }
    //End:Commented By Harikesh on 03-Nov-2020 for Defect#12437
    if (this.manageOemMoel.disinfectionCultureEvents < 0 || this.manageOemMoel.disinfectionCultureEvents == null || this.manageOemMoel.disinfectionCultureEvents === undefined || this.manageOemMoel.disinfectionCultureEvents.toString() == "") {
      this.isModelValid = false;
      modelErrors.push("Please enter Events: Disinfection and Culture.");
    } else {
      if (isNaN(this.manageOemMoel.disinfectionCultureEvents) == true) {
        modelErrors.push("Events: Disinfection and Culture must be a numerical value.");
      }
    }
    if(this.manageOemMoel.softwareVersion1VersionNo==null && this.manageOemMoel.softwareVersion2VersionNo==null && this.manageOemMoel.softwareVersion3VersionNo==null)
    {
      modelErrors.push("Please select if the model is software enabled.");
    }
    if ((this.manageOemMoel.softwareVersion1 == "" || this.manageOemMoel.softwareVersion1 == null || this.manageOemMoel.softwareVersion1 === undefined) && this.manageOemMoel.softwareVersion1VersionNo == 1) {
      modelErrors.push("Please select software version 1 for the model.");
    }
    if ((this.manageOemMoel.softwareVersion2 == "" || this.manageOemMoel.softwareVersion2 == null || this.manageOemMoel.softwareVersion2 === undefined) && this.manageOemMoel.softwareVersion2VersionNo == 1) {
      modelErrors.push("Please select software version 2 for the model.");
    }

    if ((this.manageOemMoel.softwareVersion3 == "" || this.manageOemMoel.softwareVersion3 == null || this.manageOemMoel.softwareVersion3 === undefined) && this.manageOemMoel.softwareVersion3VersionNo == 1) {
      modelErrors.push("Please select software version 3 for the model.");
    }
    return modelErrors;
  }

  doSaveSRMaintenance(type: number) {
    var maintSaved = null;
    var params = {
      pmScheduleId: 0,
      add: 0,
      scheduleFrequencyId: 0
    };
    this.TypeSelected = type;
    if (type == 1) {
      
      var modelscheduleid =this.ngmodelScheduleId_1;
      //( < HTMLInputElement > document.getElementById('modelScheduleId_1')).value;
      this.GetModelScheduleParam.MODELSCHEDULEID = parseInt(modelscheduleid);
      this.GetModelScheduleParam.ModelId = this.manageOemMoel.ModelId;
      this.GetModelScheduleParam.SCHEDULETYPEID = type;
      this.InsModelScheduleParam.ScheduleTypeID = type;
      this.InsModelScheduleParam.ServiceRequestTypeId = this.manageOemMoel.ServiceRequestTypeId1;
      this.InsModelScheduleParam.ScheduleFrequencyId = this.manageOemMoel.ScheduleFrequencyId1;
      this.InsModelScheduleParam.isAlertEnabledFlag = this.manageOemMoel.isAlertEnabledFlag1;
      this.InsModelScheduleParam.workTypeId = 1;
      this.InsModelScheduleParam.daysBeforeZero = this.manageOemMoel.daysBeforeZero1;
      this.InsModelScheduleParam.SQACodeId = this.manageOemMoel.SQACodeId1;
      this.InsModelScheduleParam.SQASubCodeId = this.manageOemMoel.SQASubCodeId1;
      this.InsModelScheduleParam.PMScheduleId = this.manageOemMoel.PMScheduleId1;
      this.updateEquipmentScheduleByModelParam.modelId = this.manageOemMoel.ModelId;
      this.GetModelScheduleParam.MODELSCHEDULEID = parseInt(modelscheduleid);
      this.GetModelScheduleParam.ModelId = this.manageOemMoel.ModelId;
      this.GetModelScheduleParam.SCHEDULETYPEID = type;
      this.InsModelScheduleParam.ScheduleTypeID = type;
      this.InsModelScheduleParam.ServiceRequestTypeId = this.manageOemMoel.ServiceRequestTypeId1;
      this.InsModelScheduleParam.ScheduleFrequencyId = this.manageOemMoel.ScheduleFrequencyId1;
      this.InsModelScheduleParam.isAlertEnabledFlag = this.manageOemMoel.isAlertEnabledFlag1;
      this.InsModelScheduleParam.workTypeId = 1;
      this.InsModelScheduleParam.daysBeforeZero = this.manageOemMoel.daysBeforeZero1;
      this.InsModelScheduleParam.SQACodeId = this.manageOemMoel.SQACodeId1;
      this.InsModelScheduleParam.SQASubCodeId = this.manageOemMoel.SQASubCodeId1;
      this.updateEquipmentScheduleByModelParam.modelId = this.manageOemMoel.ModelId;
      this.updateModelScheduleParam.ModelId = this.manageOemMoel.ModelId;
      this.updateModelScheduleParam.ModelScheduleID = parseInt(modelscheduleid);
      this.updateModelScheduleParam.SQACodeId = this.manageOemMoel.SQACodeId1;
      this.updateModelScheduleParam.ServiceRequestTypeId = this.manageOemMoel.ServiceRequestTypeId1;
      this.updateModelScheduleParam.ScheduleFrequencyId = this.manageOemMoel.ScheduleFrequencyId1;
      this.updateModelScheduleParam.isAlertEnabledFlag = this.manageOemMoel.isAlertEnabledFlag1;
      this.updateModelScheduleParam.SCHEDULETYPEID = type;
      this.updateModelScheduleParam.workTypeId = 1;
      this.updateModelScheduleParam.daysBeforeZero = this.manageOemMoel.daysBeforeZero1;
      this.updateModelScheduleParam.SQACodeId = this.manageOemMoel.SQACodeId1;
      this.updateModelScheduleParam.SQASubCodeId = this.manageOemMoel.SQASubCodeId1;
      this.updatePMScheduleParam.ModelId = this.manageOemMoel.ModelId;
      this.updatePMScheduleParam.PMScheduleID = this.manageOemMoel.PMScheduleId1;
      this.updateEquipmentScheduleByModelParam.modelId = this.manageOemMoel.ModelId;
      
      params.pmScheduleId = 0;

      params.add = 0;
      if (modelscheduleid == "" || modelscheduleid == null || modelscheduleid == undefined) {
        params.add = 1;
      }

      if (type == 1) {
        params.pmScheduleId = this.manageOemMoel.PMScheduleId1;
        this.InsModelScheduleParam.PMScheduleId = this.manageOemMoel.PMScheduleId1;
        params.scheduleFrequencyId = 9;
        this.InsModelScheduleParam.ScheduleFrequencyId = 9;
      }
      this.saveSchedule(params);

    }
    if (type == 2) {

      //var modelscheduleid = ( < HTMLInputElement > document.getElementById('modelScheduleId_2')).value;
      var modelscheduleid =this.ngmodelScheduleId_2;
      this.GetModelScheduleParam.MODELSCHEDULEID = parseInt(modelscheduleid);
      this.GetModelScheduleParam.ModelId = this.manageOemMoel.ModelId;
      this.GetModelScheduleParam.SCHEDULETYPEID = type;
      this.InsModelScheduleParam.ScheduleTypeID = type;
      this.InsModelScheduleParam.ServiceRequestTypeId = this.manageOemMoel.ServiceRequestTypeId2;
      this.InsModelScheduleParam.ScheduleFrequencyId = this.manageOemMoel.ScheduleFrequencyId2;
      this.InsModelScheduleParam.isAlertEnabledFlag = this.manageOemMoel.isAlertEnabledFlag2;
      this.InsModelScheduleParam.isScheduleActiveFlag = this.manageOemMoel.isScheduleActiveFlag;
      this.InsModelScheduleParam.workTypeId = this.manageOemMoel.workTypeId;
      this.InsModelScheduleParam.daysBeforeZero = this.manageOemMoel.daysBeforeZero2;
      this.InsModelScheduleParam.SQACodeId = this.manageOemMoel.SQACodeId2;
      this.InsModelScheduleParam.SQASubCodeId = this.manageOemMoel.SQASubCodeId2;
      this.InsModelScheduleParam.PMScheduleId = this.manageOemMoel.PMScheduleId2;
      this.updateEquipmentScheduleByModelParam.modelId = this.manageOemMoel.ModelId;
      this.GetModelScheduleParam.MODELSCHEDULEID = parseInt(modelscheduleid);
      this.GetModelScheduleParam.ModelId = this.manageOemMoel.ModelId;
      this.GetModelScheduleParam.SCHEDULETYPEID = type;
      this.InsModelScheduleParam.ScheduleTypeID = type;
      this.InsModelScheduleParam.ServiceRequestTypeId = this.manageOemMoel.ServiceRequestTypeId2;
      this.InsModelScheduleParam.ScheduleFrequencyId = this.manageOemMoel.ScheduleFrequencyId2;
      this.InsModelScheduleParam.isAlertEnabledFlag = this.manageOemMoel.isAlertEnabledFlag2;
      this.InsModelScheduleParam.workTypeId = 1;
      this.InsModelScheduleParam.daysBeforeZero = this.manageOemMoel.daysBeforeZero2;
      this.InsModelScheduleParam.SQACodeId = this.manageOemMoel.SQACodeId2;
      this.InsModelScheduleParam.SQASubCodeId = this.manageOemMoel.SQASubCodeId2;
      this.updateEquipmentScheduleByModelParam.modelId = this.manageOemMoel.ModelId;
      this.updateModelScheduleParam.ModelId = this.manageOemMoel.ModelId;
      this.updateModelScheduleParam.ModelScheduleID = parseInt(modelscheduleid);
      this.updateModelScheduleParam.SQACodeId = this.manageOemMoel.SQACodeId2;
      this.updateModelScheduleParam.ServiceRequestTypeId = this.manageOemMoel.ServiceRequestTypeId2;
      this.updateModelScheduleParam.ScheduleFrequencyId = this.manageOemMoel.ScheduleFrequencyId2;
      this.updateModelScheduleParam.isAlertEnabledFlag = this.manageOemMoel.isAlertEnabledFlag2;
      this.updateModelScheduleParam.isScheduled = this.manageOemMoel.isScheduleActiveFlag;
      this.updateModelScheduleParam.SCHEDULETYPEID = type;
      this.updateModelScheduleParam.workTypeId = this.manageOemMoel.workTypeId;
      this.updateModelScheduleParam.daysBeforeZero = this.manageOemMoel.daysBeforeZero2;
      this.updateModelScheduleParam.SQACodeId = this.manageOemMoel.SQACodeId2;
      this.updateModelScheduleParam.SQASubCodeId = this.manageOemMoel.SQASubCodeId2;
      this.updatePMScheduleParam.ModelId = this.manageOemMoel.ModelId;
      this.updatePMScheduleParam.PMScheduleID = this.manageOemMoel.PMScheduleId2;
      this.updateEquipmentScheduleByModelParam.modelId = this.manageOemMoel.ModelId;
      
      params.pmScheduleId = 0;
      params.add = 0;
      if (modelscheduleid == "" || modelscheduleid == null) {
        params.add = 1;
      }
      if (type == 2) {
        this.InsModelScheduleParam.workTypeId = this.manageOemMoel.workTypeId;
        this.InsModelScheduleParam.resolutionPartId = this.manageOemMoel.resolutionPartId;
        this.InsModelScheduleParam.isScheduleActiveFlag = this.manageOemMoel.isScheduleActiveFlag;
      }
      this.saveSchedule(params);
    }
  }
  public msg: "Model info has been saved.<br />";
  public maintSaved: any;
  public saveSuccessful: number;
  public IsMaintanceValid: Boolean
  public IsModelValid: Boolean;
  public freqSel: number;
  SaveModel(event) {

    var msg = new Array();
    var errorsMaint = new Array();
    var maintSaved = new Array();
    var saveSuccessful = 0;
    var dialogTitle = "Error";
    var freqSelected_1 = this.manageOemMoel.ServiceRequestTypeId1;    
    var freqSelected_2 = this.manageOemMoel.ScheduleFrequencyId2;
    
    var errorsSave = this.isModelVlaid();
    if (isNaN(freqSelected_1) == false && freqSelected_1 != null && freqSelected_1 > 0) {
      errorsMaint = this.validateSRMaintenance(1);
      errorsSave = errorsSave.concat(errorsMaint);
    }
    if (isNaN(freqSelected_2) == false && freqSelected_2 != null && freqSelected_2 > 0) {
      errorsMaint = this.validateSRMaintenance(2);
      errorsSave = errorsSave.concat(errorsMaint);
    }
    if (errorsSave.length > 0) {

      this.errors = [];
      this.errors = errorsSave;
      this.dialogHeader = "Validation Message";
      this.ShowAlertpopup = true;
      return false;
    }
    if (errorsSave.length <= 0) {
      this.updateModelsParam.modelId = this.manageOemMoel.modelID;
      this.updateModelsParam.equipmentSubTypeId = this.manageOemMoel.equipmentSubTypeID;
      this.updateModelsParam.equipmentTypeId = this.manageOemMoel.equipmentTypeID;
      this.updateModelsParam.equipmentSubTypeId = this.manageOemMoel.equipmentSubTypeID;
      this.updateModelsParam.manufacturerId = this.manageOemMoel.manufacturerID;
      this.updateModelsParam.ModelNumber = this.manageOemMoel.modelName;
      this.updateModelsParam.hasClock = this.manageOemMoel.HasClock;
      this.updateModelsParam.pmEvents = this.manageOemMoel.pmEvents;
      this.updateModelsParam.ModifiedBy = this.userDetail.userId;
      this.updateModelsParam.disinfectionCultureEvents = this.manageOemMoel.disinfectionCultureEvents;
      this.updateModelsParam.IsNickNameEnabled = this.manageOemMoel.nicknameEnabled;
      var sfoterwareVersion1 = null;
      var sfoterwareVersion2 = null;
      var sfoterwareVersion3 = null;
      var sfoterwareVersion4 = null;
      if (this.manageOemMoel.softwareVersion1 != null) {
        sfoterwareVersion1 = new String(this.manageOemMoel.softwareVersion1 + '_' + this.manageOemMoel.softwareVersion1VersionNo + ',');
      }
      if (this.manageOemMoel.softwareVersion2 != null) {
        sfoterwareVersion2 = new String(this.manageOemMoel.softwareVersion2 + '_' + this.manageOemMoel.softwareVersion2VersionNo) + ',';
      }
      if (this.manageOemMoel.softwareVersion3 != null) {
        sfoterwareVersion3 = new String(this.manageOemMoel.softwareVersion3 + '_' + this.manageOemMoel.softwareVersion3VersionNo);
      }
      if (sfoterwareVersion1 != null && sfoterwareVersion2 != null && sfoterwareVersion3 == null) {
        var sfoterwareVersion4 = sfoterwareVersion1.concat(sfoterwareVersion2.toString());
      }
      if (sfoterwareVersion1 != null && sfoterwareVersion2 != null && sfoterwareVersion3 != null) {
        sfoterwareVersion4 = sfoterwareVersion1.concat(sfoterwareVersion2.toString()).concat(sfoterwareVersion3.toString())
      }

      if (sfoterwareVersion1 != null && sfoterwareVersion2 == null && sfoterwareVersion3 == null) {
        var sfoterwareVersion4 = sfoterwareVersion1;
      }
      if (sfoterwareVersion4 != null) {
        this.updateModelsParam.EquipmentSoftwareID = sfoterwareVersion4.toString();
      } else {
        this.updateModelsParam.EquipmentSoftwareID = null;
      }
      this.updateModelsParam.IsIpAddressEnabled = this.manageOemMoel.IPAddressEnabled;
      this.CHECKMODEL.manufacturerID = this.manageOemMoel.manufacturerID;
      this.CHECKMODEL.modelId = this.manageOemMoel.modelID;
      this.CHECKMODEL.modelNumber = this.manageOemMoel.modelName;
      this.GETMODELS.equipmentTypeId = this.manageOemMoel.equipmentTypeID;
      this.GETMODELS.manufacturerId = this.manageOemMoel.manufacturerID;
      this.GetModelScheduleParam.ModelId = this.manageOemMoel.modelID;
      this.InsModelScheduleParam.ModelId = this.manageOemMoel.modelID;
      this.InsModelScheduleParam.ServiceRequestTypeId = this.manageOemMoel.ServiceRequestTypeId1;
      this.InsModelScheduleParam.ScheduleFrequencyId = this.manageOemMoel.ScheduleFrequencyId1;
      this.InsModelScheduleParam.isAlertEnabledFlag = this.manageOemMoel.isAlertEnabledFlag1;
      this.InsModelScheduleParam.workTypeId = 1;
      this.InsModelScheduleParam.daysBeforeZero = this.manageOemMoel.daysBeforeZero1;
      this.InsModelScheduleParam.SQACodeId = this.manageOemMoel.SQACodeId1;
      this.InsModelScheduleParam.SQASubCodeId = this.manageOemMoel.SQASubCodeId1;
      if (this.updateModelsParam != null) {
        var UPDATEMODEL = this.updateModelsParam;
        var CHECKMODEL = this.CHECKMODEL;

        this._ModelService.updateModel(JSON.stringify({
            UPDATEMODEL,
            CHECKMODEL
          }))
          .subscribe((allModelsResponse: any) => {
            if (allModelsResponse.result == 'Saved') {
              if (allModelsResponse.result == 'Saved') {
                msg.push("Model info has been saved.");

                saveSuccessful = 1;
              }
              if (isNaN(freqSelected_1) == false && freqSelected_1 != null && saveSuccessful == 1 && freqSelected_1 > 0) {
                this.doSaveSRMaintenance(1);
                if (maintSaved.length > 0) {

                  saveSuccessful = 1;
                }
              }
              if (isNaN(freqSelected_2) == false && freqSelected_2 != null && saveSuccessful == 1 && freqSelected_2 > 0) {

                this.doSaveSRMaintenance(2);
                if (maintSaved.length > 0) {
                  msg.push("Model info has been saved.");
                  msg.push("Custom SR Schedule / Alert has been saved.");                  
                  saveSuccessful = 1;
                }
              }
              if (saveSuccessful == 1) {
                dialogTitle = 'Save Successful';
              }
              if (freqSelected_1 <= 0 && freqSelected_2 <= 0 && saveSuccessful == 1) {
                this.errors = [];
                this.errors = msg
                this.dialogHeader = "Save Successful";
                this.ShowAlertpopup = true;
                this.ngmodelScheduleId_1="";
                  this.ngmodelScheduleId_2="";
                this.doCancelEditModel(this.manageOemMoel.manufacturerID);
              }

            } else {
              msg += allModelsResponse.errors;
            }

          }, (respose: Response) => {});
      }

    }    
  }
  saveSchedule(newMod: any) {

    var msg = new Array();
    var ret = null;
    var retData = null;
    var proxyParams = newMod;
    proxyParams.object = 'modelObj';

    if (newMod.add) {
      //add Model Schedule
      if (this.InsModelScheduleParam != null) {

        if (this.InsModelScheduleParam.ScheduleTypeID == 1 && this.manageOemMoel.modelID > 0 && this.manageOemMoel.modelID != undefined) {
          this.InsModelScheduleParam.ModelId = this.manageOemMoel.modelID;
          this.updateEquipmentScheduleByModelParam.modelId = this.manageOemMoel.modelID;
          this.GetModelScheduleParam.ModelId = this.manageOemMoel.modelID;
        }

        if (this.InsModelScheduleParam.ScheduleTypeID == 1 && this.manageOemMoel.modelID == undefined) {
          this.InsModelScheduleParam.ModelId = this.manageOemMoel.ModelId;
          this.updateEquipmentScheduleByModelParam.modelId = this.manageOemMoel.ModelId;
          this.GetModelScheduleParam.ModelId = this.manageOemMoel.ModelId;

        }

        if (this.InsModelScheduleParam.ScheduleTypeID == 2 && this.manageOemMoel.ModelId == 0) {
          this.InsModelScheduleParam.ModelId = this.manageOemMoel.modelID;
          this.updateEquipmentScheduleByModelParam.modelId = this.manageOemMoel.modelID;
          this.GetModelScheduleParam.ModelId = this.manageOemMoel.modelID;
        }

        var ADDMODELSCHEDULE = this.InsModelScheduleParam;
        var UPDATEEQUIPMENTSCHEDULEBYMODEL = this.updateEquipmentScheduleByModelParam;
        var GETMODELSCHEDULE = this.GetModelScheduleParam;
        this._ModelService.addModelSchedule(JSON.stringify({
          ADDMODELSCHEDULE,
          UPDATEEQUIPMENTSCHEDULEBYMODEL,
          GETMODELSCHEDULE
        })).subscribe((addModelScheduleResponse: any) => {
          if (addModelScheduleResponse.ModelScheduleId > 0) {
            retData = addModelScheduleResponse
            this.modelAndMaintanceSave.maintaicheSaved = 1;
            //Update PMSchedule
           //Start:Commented By Harikesh on 17-Sep-2020 for duplicate entry
            /*
            this._ModelService.addModelSchedule(JSON.stringify({
              ADDMODELSCHEDULE,
              UPDATEEQUIPMENTSCHEDULEBYMODEL,
              GETMODELSCHEDULE
            })).subscribe((addModelScheduleResponse: any) => {
            */
            //End:Commented By Harikesh on 17-Sep-2020 for duplicate entry
            
              if (addModelScheduleResponse.ModelScheduleId > 0) {
                retData = addModelScheduleResponse
                this.modelAndMaintanceSave.maintaicheSaved = 1;
                //Update PMSchedule  
                this.updatePMScheduleParam.PMScheduleID = ADDMODELSCHEDULE.PMScheduleId;
                this.updatePMScheduleParam.ModelId = ADDMODELSCHEDULE.ModelId;
                var UPDATEPMSCHEDULE = this.updatePMScheduleParam;

                this._ModelService.updatePMSchedule(JSON.stringify({
                  UPDATEPMSCHEDULE
                })).subscribe((updatePMScheduleResponse: any) => {
                  msg.push("Model info has been saved.");
                  msg.push("Maintenance SR Schedule / Alert has been saved.");
                  this.errors = []
                  this.errors = msg;
                  this.dialogHeader = "Save Successful";
                  this.ShowAlertpopup = true;
                  this.doCancelEditModel(this.manageOemMoel.manufacturerID);

                }, (respose: Response) => {});
                //END

              }
            //Start:Commented By Harikesh on 17-Sep-2020 for duplicate entry
            /*
              }, (respose: Response) => {
                // handle error here
              });
            */
            //End:Commented By Harikesh on 17-Sep-2020 for duplicate entry
            //END               
          }
        }, (respose: Response) => {
          // handle error here
        });
      }
    } else { 
      //Update Model Schedule

      if (this.updateModelScheduleParam != null) {
        this.updateModelScheduleParam.ModelId = this.manageOemMoel.modelID;
        this.updatePMScheduleParam.ModelId = this.manageOemMoel.modelID;
        this.updateEquipmentScheduleByModelParam.modelId = this.manageOemMoel.modelID;
        // if(this.TypeSelected==1)
        // {
        // this.updateModelScheduleParam.PMScheduleId=this.manageOemMoel.PMScheduleId1;
        // }
        var UPDATEMODELSCHEDULE = this.updateModelScheduleParam;
        var UPDATEPMSCHEDULE = this.updatePMScheduleParam;
        var UPDATEEQUIPMENTSCHEDULEBYMODEL = this.updateEquipmentScheduleByModelParam;
        this._ModelService.updateModelSchedule(JSON.stringify({
          UPDATEMODELSCHEDULE,
          UPDATEPMSCHEDULE,
          UPDATEEQUIPMENTSCHEDULEBYMODEL
        })).subscribe((addModelScheduleResponse: any) => {
          if (addModelScheduleResponse.result == 'Saved') {
            retData = addModelScheduleResponse
            msg.push("Model info has been saved.");
            msg.push("Maintenance SR Schedule / Alert has been saved.");
            msg.push("Custom SR Schedule / Alert has been saved.");            
            this.errors = []
            this.errors = msg;
            this.dialogHeader = "Save Successful";
            this.ShowAlertpopup = true;
            this.ngmodelScheduleId_1="";
            this.ngmodelScheduleId_2="";
            this.doCancelEditModel(this.manageOemMoel.manufacturerID);
          }
        }, (respose: Response) => {});
      }
    }

  }

  validateSRMaintenance(type: number) {
    var errors = new Array();
    var maxDays = 0
    if (type == 1) {
      var frequency = ( < HTMLInputElement > document.getElementById('scheduleFrequency_1')).value;
      var daysBeforeZero = this.manageOemMoel.daysBeforeZero1;
      var sqa = this.manageOemMoel.SQACodeId1;
      var sqaSub = this.manageOemMoel.SQASubCodeId1;
      maxDays = 15;
      var alertEnabled = this.manageOemMoel.isAlertEnabledFlag1;
      if (alertEnabled == null || alertEnabled == undefined) {
        errors.push("Enable Alert is required.");
      }
      if (this.manageOemMoel.daysBeforeZero1 <= 0) {
        errors.push("Days Before \"Day Zero\" is required.");
      }
      if (this.manageOemMoel.SQACodeId1 == null || isNaN(this.manageOemMoel.SQACodeId1) == true || this.manageOemMoel.SQACodeId1 == 0) {
        errors.push("SQA Code is required.");
      }
      if (errors.length == 0) {
        if (isNaN(this.manageOemMoel.daysBeforeZero1) == true) {
          errors.push("Days Before Day Zero must be numeric.");
        } else {
          if (this.manageOemMoel.daysBeforeZero1 > maxDays) {
            errors.push("Days Before \"Day Zero\" cannot be greater than " + maxDays + ".");
          }
        }
      }
    }
    // custom tab validation
    if (type == 2) {
      var frequency = ( < HTMLInputElement > document.getElementById('scheduleFrequency_2')).value;;
      var daysBeforeZero = this.manageOemMoel.daysBeforeZero2;
      var sqa = this.manageOemMoel.SQACodeId2;
      var sqaSub = this.manageOemMoel.SQASubCodeId2;
      maxDays = 15;
      if (type == 2) {
        maxDays = 45;
        if (this.manageOemMoel.workTypeId == null || this.manageOemMoel.workTypeId == 0 || isNaN(this.manageOemMoel.workTypeId) == true) {
          errors.push("PM Type is required.");
        }
        if (this.manageOemMoel.isAlertEnabledFlag2 == null || this.manageOemMoel.isAlertEnabledFlag2 == undefined) {
          errors.push("Enable Alert is required.");
        }
        if (this.manageOemMoel.isScheduleActiveFlag == null || this.manageOemMoel.isScheduleActiveFlag == undefined) {
          errors.push("Schedule Active is required.");
        }
      }
      if (this.manageOemMoel.daysBeforeZero2 <= 0) {
        errors.push("Days Before \"Day Zero\" is required.");
      }
      if (this.manageOemMoel.SQACodeId2 == null || isNaN(this.manageOemMoel.SQACodeId2) == true || this.manageOemMoel.SQACodeId2 == 0) {
        errors.push("SQA Code is required.");
      }
      if (errors.length == 0) {
        if (isNaN(this.manageOemMoel.daysBeforeZero2) == true) {
          errors.push("Days Before Day Zero must be numeric.");
        } else {
          if (this.manageOemMoel.daysBeforeZero2 > maxDays) {
            errors.push("Days Before \"Day Zero\" cannot be greater than " + maxDays + ".");
          }
        }
        if (isNaN(this.manageOemMoel.daysBeforeZero2) == true) {
          errors.push("Days After Day Zero must be numeric.");
        }
      }
    }
    return errors;

  }
  deleteModel(event) {
    this.confirmationService.confirm({
      message: 'This will delete the currently selected model. Continue?',
      header: 'Confirm Delete',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteModelParam.ModelId = this.manageOemMoel.modelID;
        this.deleteModelParam.isActiveFlag = 0;
        if (this.deleteModelParam != null) {
          var UPDATEMODELACTIVEFLAG = this.deleteModelParam;
          this._ModelService.updateModelActiveFlag(JSON.stringify({
              UPDATEMODELACTIVEFLAG
            }))
            .subscribe((deleteModelsResponse: any) => {
              if (deleteModelsResponse.updateModelActiveFlag == 'Saved Sucessfully') {
                var msg = new Array();
                msg.push("Model has been deleted.");
                this.errors = []
                this.errors = msg;
                this.dialogHeader = "Delete Successful";
                this.ShowAlertpopup = true;
                this.hideAdd = false;
                this.hideDelete = true;
                this.hideCancel = true;
                this.hideSave = true;
                this.doCancelEditModel(this.manageOemMoel.manufacturerID);
              }
            }, (respose: Response) => {});
        }
      },
      reject: () => {}
    });
  }

  deleteManufacturer(event) {

    this.confirmationService.confirm({
      message: 'This will delete the currently selected manufacturer. Continue?',
      header: 'Confirm Delete',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.UPDATEMANUFACTURERACTIVEFLAG.manufacturerID = this.manageOemMoelmnf.manufacturerIDMnf;
        this.UPDATEMANUFACTURERACTIVEFLAG.isActiveFlag = 0;
        if (this.UPDATEMANUFACTURERACTIVEFLAG != null) {
          var UPDATEMANUFACTURERACTIVEFLAG = this.UPDATEMANUFACTURERACTIVEFLAG;
          this._ManufacturerService.updateManufacturerActiveFlag(JSON.stringify({
              UPDATEMANUFACTURERACTIVEFLAG
            }))
            .subscribe((deleteManufacturerResponse: any) => {
              if (deleteManufacturerResponse.length == 0) {
                var msg = new Array();
                msg.push("Manufacturer deleted Sucessfully.");
                this.errors = []
                this.errors = msg;
                this.dialogHeader = "Delete Successful";
                this.ShowAlertpopup = true;
                this.cancelManufacturar();
              }
            }, (respose: Response) => {});
        }
        this.hideAddMnfr = false;
        this.hideSaveMnfr = true;
        this.hideDeleteMnfr = true;
        this.hideDeleteMnfr = true;
        this.hideCancelMnfr = true;
      },
      reject: () => {}
    });

  }
  LoadSubType(event) {
    if (this.manageOemMoel.equipmentTypeID != null) {
      this.hideSubType = false;
      this.hideAlerts = false;
      this.getEquipmentSubtypes(this.manageOemMoel.equipmentTypeID);
      this.getEquipmentTypeSQACodesParam.equipmentTypeId = this.manageOemMoel.equipmentTypeID;
      this.getEquipmentTypeSQACodes(this.getEquipmentTypeSQACodesParam)
    } else {
      this.hideSubType = true;
      this.hideAlerts = true;
    }
    if (this.manageOemMoel.ServiceRequestTypeId1 > 0) {
      this.hideAlerts = true;
    }

  }
  cancelManufacturar() {
    this.manageOemMoelmnf.manufacturerNameMnf = '';
    this.manageOemMoelmnf.manufacturerIDMnf = 0;
    this.manageOemMoelmnf.iProcVendorId = null;
    this.manageOemMoelmnf.isActiveFlag = null;
    this.manageOemMoelmnf.warrantyDefaultEquipment = 30;
    this.manageOemMoelmnf.warrantyDefaultParts = 30;
    this.getManufacturers(this.getManufacturerParam);
    this.hideAddMnfr = false;
    this.hideSaveMnfr = true;
    this.hideDeleteMnfr = true;
    this.hideDeleteMnfr = true;
    this.hideCancelMnfr = true;
  }
  cancelMnf(eventId: string) {
    this.manageOemMoelmnf.manufacturerNameMnf = '';
    this.manageOemMoelmnf.manufacturerIDMnf = 0;
    this.manageOemMoelmnf.iProcVendorId = null;
    this.manageOemMoelmnf.isActiveFlag = null;
    this.manageOemMoelmnf.warrantyDefaultEquipment = 30;
    this.manageOemMoelmnf.warrantyDefaultParts = 30;
    this.hideAddMnfr = false;
    this.hideSaveMnfr = true;
    this.hideDeleteMnfr = true;
    this.hideDeleteMnfr = true;
    this.hideCancelMnfr = true;
  }
  doCancelModel(eventId: string) {
    this.hideSave = true;
    this.hideDelete = true;
    this.manageOemMoel = {
      manufacturerName: '',
      iProcVendorId: null,
      warrantyDefaultEquipment: 0,
      warrantyDefaultParts: 0,
      userId: 0,
      isActiveFlag: 0,
      manufacturerID: 0,
      modelNumber: '',
      activeEquipCount: 0,
      otherEquipCount: null,
      pmEvents: null,
      disinfectionCultureEvents: null,
      equipmentWarrantyID: 0,
      partWarrantyID: 0,
      CreatedBy: '',
      DateCreated: '',
      ModifiedBy: '',
      DateModified: '',
      softwareVersion2VersionNo: null,
      softwareVersion1VersionNo: null,
      softwareVersion3VersionNo: null,
      modelName: '',
      HasClock: null,
      equipmentTypeID: 0,
      IPAddressEnabled: null,
      nicknameEnabled: null,
      modelID: 0,
      equipmentSubTypeID: 0,
      ModelId: 0,
      workTypeId: 0,
      resolutionPartId: 0,
      isScheduleActiveFlag: 0,
      ScheduleTypeID1: 0,
      ServiceRequestTypeId1: 0,
      ScheduleFrequencyId1: 0,
      PMScheduleId1: 0,
      daysBeforeZero1: null,
      isAlertEnabledFlag1: 0,
      SQACodeId1: 0,
      SQASubCodeId1: 0,
      ScheduleTypeID2: 0,
      ServiceRequestTypeId2: 0,
      ScheduleFrequencyId2: 0,
      PMScheduleId2: 0,
      daysBeforeZero2: 0,
      isAlertEnabledFlag2: 0,
      SQACodeId2: 0,
      SQASubCodeId2: 0
    };
    this.hideAlerts = true;
    this.hideSRScheduleAlerts = true;
    this.hideCancel = true;
    this.hideAdd = false;
    this.ngmodelScheduleId_1="";
    this.ngmodelScheduleId_2="";
  }
  doCancelEditModel(manufacturerIDParam: any) {
    this.hideSave = true;
    this.hideDelete = true;
    this.manageOemMoel = {
      manufacturerName: '',
      iProcVendorId: null,
      warrantyDefaultEquipment: 0,
      warrantyDefaultParts: 0,
      userId: 0,
      isActiveFlag: 0,
      manufacturerID: 0,
      modelNumber: '',
      activeEquipCount: 0,
      otherEquipCount: null,
      pmEvents: null,
      disinfectionCultureEvents: null,
      equipmentWarrantyID: 0,
      partWarrantyID: 0,
      CreatedBy: '',
      DateCreated: '',
      ModifiedBy: '',
      DateModified: '',
      softwareVersion2VersionNo: null,
      softwareVersion1VersionNo: null,
      softwareVersion3VersionNo: null,
      modelName: '',
      HasClock: null,
      equipmentTypeID: 0,
      IPAddressEnabled: null,
      nicknameEnabled: null,
      modelID: 0,
      equipmentSubTypeID: 0,
      ModelId: 0,
      workTypeId: 0,
      resolutionPartId: 0,
      isScheduleActiveFlag: 0,
      ScheduleTypeID1: 0,
      ServiceRequestTypeId1: 0,
      ScheduleFrequencyId1: 0,
      PMScheduleId1: 0,
      daysBeforeZero1: null,
      isAlertEnabledFlag1: 0,
      SQACodeId1: 0,
      SQASubCodeId1: 0,
      ScheduleTypeID2: 0,
      ServiceRequestTypeId2: 0,
      ScheduleFrequencyId2: 0,
      PMScheduleId2: 0,
      daysBeforeZero2: 0,
      isAlertEnabledFlag2: 0,
      SQACodeId2: 0,
      SQASubCodeId2: 0
    };
    this.hideAlerts = true;
    this.hideSRScheduleAlerts = true;
    this.hideCancel = true;
    this.hideAdd = false;
    if (manufacturerIDParam > 0) {
      this.getModelsParamInit.manufacturerId = manufacturerIDParam;
      this.getModels(this.getModelsParamInit);
    } else {
      if (this.getModelsParamInit.manufacturerId > 0) {
        this.getModelsParamInit.manufacturerId = this.getModelsParamInit.manufacturerId
        this.getModels(this.getModelsParamInit);
      }
    }

  }
  addManufacturar(event) {
    if (this.validateManufacturer() == true) {
      this.ADDMANUFACTURER.iProcVendorId = this.manageOemMoelmnf.iProcVendorId;
      if (this.manageOemMoelmnf.isActiveFlag == null) {
        this.ADDMANUFACTURER.isActiveFlag = 0;
      } else {
        this.ADDMANUFACTURER.isActiveFlag = this.manageOemMoelmnf.isActiveFlag;
      }
      this.ADDMANUFACTURER.manufacturerName = this.manageOemMoelmnf.manufacturerNameMnf;
      this.ADDMANUFACTURER.userId = this.userDetail.userId;
      this.ADDMANUFACTURER.warrantyDefaultEquipment = this.manageOemMoelmnf.warrantyDefaultEquipment;
      this.ADDMANUFACTURER.warrantyDefaultParts = this.manageOemMoelmnf.warrantyDefaultParts;
      this.CHECKMANUFACTURER.manufacturerName = this.manageOemMoelmnf.manufacturerNameMnf;
      this.CHECKMANUFACTURER.manufacturerID = this.manageOemMoelmnf.manufacturerID;
      if (this.manageOemMoelmnf.iProcVendorId > 0 && this.manageOemMoelmnf.iProcVendorId != null) {
        if (this.VALIDATEIPROC != null) {
          this.VALIDATEIPROC.iprocid = this.manageOemMoelmnf.iProcVendorId
          this.VALIDATEIPROC.manufacturerid = this.manageOemMoelmnf.manufacturerID;
          var VALIDATEIPROC = this.VALIDATEIPROC;
          this._EquipmentService.validateIproc(JSON.stringify({
              VALIDATEIPROC
            }))
            .subscribe((validateIprocResponse: any) => {
              {
                if (validateIprocResponse.valIproc.length > 0) {
                  var msg = new Array();
                  msg.push("Duplicate iProcurementID found.");
                  this.errors = []
                  this.errors = msg;
                  this.dialogHeader = "Validation Error";
                  this.ShowAlertpopup = true;
                } else {
                  if (this.ADDMANUFACTURER != null) {
                    var ADDMANUFACTURER = this.ADDMANUFACTURER;
                    var CHECKMANUFACTURER = this.CHECKMANUFACTURER;
                    this._ManufacturerService.addManufacturer(JSON.stringify({
                        ADDMANUFACTURER,
                        CHECKMANUFACTURER
                      }))
                      .subscribe((allModelsResponse: any) => {
                        {
                          if (allModelsResponse.alreadyexists >= 1) {
                            var msg = new Array();
                            msg.push("Manufacturer Name already exists.");
                            this.errors = []
                            this.errors = msg;
                            this.dialogHeader = "Validation Error";
                            this.ShowAlertpopup = true;
                          } else {
                            if (allModelsResponse.manufacturerId.length > 0) {
                              var msg = new Array();
                              msg.push("Manufacturer successfully added.");
                              this.errors = []
                              this.errors = msg;
                              this.dialogHeader = "Save Successful";
                              this.ShowAlertpopup = true;
                              this.cancelManufacturar();
                              this.GetManufacturar();
                            }
                          }

                        }
                      }, (respose: Response) => {});
                  }
                }

              }
            }, (respose: Response) => {});
        }

      } else {
        if (this.ADDMANUFACTURER != null) {
          var ADDMANUFACTURER = this.ADDMANUFACTURER;
          var CHECKMANUFACTURER = this.CHECKMANUFACTURER;
          this._ManufacturerService.addManufacturer(JSON.stringify({
              ADDMANUFACTURER,
              CHECKMANUFACTURER
            }))
            .subscribe((allModelsResponse: any) => {
              {
                if (allModelsResponse.alreadyexists >= 1) {
                  var msg = new Array();
                  msg.push("Manufacturer Name already exists.");
                  this.errors = []
                  this.errors = msg;
                  this.dialogHeader = "Validation Error";
                  this.ShowAlertpopup = true;
                } else {
                  if (allModelsResponse.manufacturerId.length > 0) {
                    var msg = new Array();
                    msg.push("Manufacturer successfully added.");
                    this.errors = []
                    this.errors = msg;
                    this.dialogHeader = "Save Successful";
                    this.ShowAlertpopup = true;
                    this.cancelManufacturar();
                    this.GetManufacturar();
                  }
                }
              }
            }, (respose: Response) => {});
        }
      }
    }

  }
  saveManufacturar(event) {
    if (this.validateManufacturer() == true) {
      this.UPDATEMANUFACTURER.iProcVendorId = this.manageOemMoelmnf.iProcVendorId;
      if (this.manageOemMoelmnf.isActiveFlag == null) {
        this.UPDATEMANUFACTURER.isActiveFlag = 0;
      } else {
        this.UPDATEMANUFACTURER.isActiveFlag = this.manageOemMoelmnf.isActiveFlag;
      }
      this.UPDATEMANUFACTURER.manufacturerName = this.manageOemMoelmnf.manufacturerNameMnf;
      this.UPDATEMANUFACTURER.userId = this.userDetail.userId;
      this.UPDATEMANUFACTURER.warrantyDefaultEquipment = this.manageOemMoelmnf.warrantyDefaultEquipment;
      this.UPDATEMANUFACTURER.warrantyDefaultParts = this.manageOemMoelmnf.warrantyDefaultParts;
      this.UPDATEMANUFACTURER.manufacturerID = this.manageOemMoelmnf.manufacturerIDMnf;
      this.CHECKMANUFACTURER.manufacturerName = this.manageOemMoelmnf.manufacturerNameMnf;
      this.CHECKMANUFACTURER.manufacturerID = this.manageOemMoelmnf.manufacturerIDMnf;
      if (this.manageOemMoelmnf.iProcVendorId >= 0 && this.manageOemMoelmnf.iProcVendorId != null) {
        if (this.VALIDATEIPROC != null) {
          this.VALIDATEIPROC.iprocid = this.manageOemMoelmnf.iProcVendorId
          this.VALIDATEIPROC.manufacturerid = this.manageOemMoelmnf.manufacturerIDMnf;
          var VALIDATEIPROC = this.VALIDATEIPROC;
          this._EquipmentService.validateIproc(JSON.stringify({
              VALIDATEIPROC
            }))
            .subscribe((validateIprocResponse: any) => {
              {
                if (validateIprocResponse.valIproc.length > 0) {
                  var msg = new Array();
                  msg.push("Duplicate iProcurementID found.");
                  this.errors = []
                  this.errors = msg;
                  this.dialogHeader = "Validation Error";
                  this.ShowAlertpopup = true;
                  this.IsValidateManufacturer = false;
                } else {
                  if (this.UPDATEMANUFACTURER != null) {
                    var UPDATEMANUFACTURER = this.UPDATEMANUFACTURER;
                    var CHECKMANUFACTURER = this.CHECKMANUFACTURER;
                    this._ManufacturerService.updateManufacturer(JSON.stringify({
                        UPDATEMANUFACTURER,
                        CHECKMANUFACTURER
                      }))
                      .subscribe((allModelsResponse: any) => {
                        {
                          if (allModelsResponse.saveManufacturer.length == 0) {
                            var msg = new Array();
                            msg.push("Manufacturer info has been saved.");
                            this.errors = []
                            this.errors = msg;
                            this.dialogHeader = "Save Successful";
                            this.ShowAlertpopup = true;
                            this.cancelManufacturar();
                            this.GetManufacturar();

                          }
                        }
                      }, (respose: Response) => {});
                  }
                }

              }
            }, (respose: Response) => {});
        }

      } else {
        if (this.UPDATEMANUFACTURER != null) {
          var UPDATEMANUFACTURER = this.UPDATEMANUFACTURER;
          var CHECKMANUFACTURER = this.CHECKMANUFACTURER;
          this._ManufacturerService.updateManufacturer(JSON.stringify({
              UPDATEMANUFACTURER,
              CHECKMANUFACTURER
            }))
            .subscribe((allModelsResponse: any) => {
              {
                if (allModelsResponse.saveManufacturer.length == 0) {
                  var msg = new Array();
                  msg.push("Manufacturer info has been saved.");
                  this.errors = []
                  this.errors = msg;
                  this.dialogHeader = "Save Successful";
                  this.ShowAlertpopup = true;
                  this.cancelManufacturar();
                  this.GetManufacturar();
                }
              }
            }, (respose: Response) => {});
        }
      }

    }

  }

  IsValidateManufacturer: boolean
  validateManufacturer() {
    this.IsValidateManufacturer = true;
    if (this.manageOemMoelmnf.manufacturerNameMnf.length == 0) {
      this.IsValidateManufacturer = false;
      var msg = new Array();
      msg.push("Please enter a manufacturer name.");
      this.errors = []
      this.errors = msg;
      this.dialogHeader = "Validation Error";
      this.ShowAlertpopup = true;
    } else if (this.manageOemMoelmnf.manufacturerNameMnf.length < 2) {
      this.IsValidateManufacturer = false;
      var msg = new Array();
      msg.push("Please enter a manufacturer name at least three characters in length.");
      this.errors = []
      this.errors = msg;
      this.dialogHeader = "Validation Error";
      this.ShowAlertpopup = true;
    }

    if (isNaN(this.manageOemMoelmnf.iProcVendorId)) {
      this.IsValidateManufacturer = false;
      var msg = new Array();
      msg.push("iProcurementID must be numeric");
      this.errors = []
      this.errors = msg;
      this.dialogHeader = "Validation Error";
      this.ShowAlertpopup = true;

    }
    return this.IsValidateManufacturer;

  }

  public getManufacturersRefetch(GETMANUFACTURERS: any) {
    if (GETMANUFACTURERS != null) {
      this._ManufacturerService.getManufacturers(JSON.stringify({
          GETMANUFACTURERS
        }))
        .subscribe((allManufacturersResponse: any) => {
          if (allManufacturersResponse.manufacturers.length > 0) {
            this.ManuFacturerListDataPrnt = [];
            this.ManuFacturerListDataPrnt = allManufacturersResponse.manufacturers;

          }
        }, (respose: Response) => {
          this.ManuFacturerListDataPrnt = [];
        });
    }
  }
  public getModelsRefetch(GETMODELS: any) {
    if (GETMODELS != null) {
      this._ModelService.getModels(JSON.stringify({
          GETMODELS
        }))
        .subscribe((allModelsResponse: any) => {
          if (allModelsResponse.models.length > 0) {
            this.ModelListDataPrnt = [];
            this.ModelListDataPrnt = allModelsResponse.models;
          }
        }, (respose: Response) => {
          this.ModelListDataPrnt = [];
        });
    }
  }
  public getModels(GETMODELS: any) {
    this.SearchData=[];
    if (GETMODELS != null) {
      this.ShowLodingGrid = true;
      this._ModelService.getModels(JSON.stringify({
        GETMODELS
      })).subscribe((allModelsResponse: any) => {
        this.SearchData = [];
        if (allModelsResponse.models.length > 0) {
           this.SearchData = allModelsResponse.models;
          this.ShowLodingGrid = false;
        }
      }, (respose: Response) => {
        this.SearchData = [];
        this.ShowLodingGrid = false;
      });
    }
  }
  public getManufacturers(GETMANUFACTURERS: any) {
    if (GETMANUFACTURERS != null) {
      this.ShowLodingGrid = true;
      this._ManufacturerService.getManufacturers(JSON.stringify({
          GETMANUFACTURERS
        }))
        .subscribe((allManufacturersResponse: any) => {
            if (allManufacturersResponse.manufacturers.length > 0) {
              this.ManuFacturerListData = allManufacturersResponse.manufacturers;
              this.ShowLodingGrid = false;
            }
          }, (respose: Response) => {
            this.ShowLodingGrid = false;
          }

        );
    }
  }
  
  onRowSelect(event: any, template ? : any) {    
    
    this.manageOemMoel = {
      manufacturerName: event.data.manufacturername,
      modelNumber: event.data.modelnumber,
      activeEquipCount: event.data.activeEquipCount,
      otherEquipCount: event.data.otherEquipCount,
      pmEvents: event.data.pmEvents,
      disinfectionCultureEvents: event.data.disinfectionCultureEvents,
      equipmentWarrantyID: 0,
      partWarrantyID: 0,
      CreatedBy: '',
      DateCreated: '',
      ModifiedBy: '',
      DateModified: '',
      softwareVersion2VersionNo: null,
      softwareVersion1VersionNo: null,
      softwareVersion3VersionNo: null,
      manufacturerID: event.data.manufacturerid,
      modelName: event.data.modelnumber,
      HasClock: event.data.hasClock,
      equipmentTypeID: event.data.equipmenttypeid,
      //defect id: 12310 dram
      IPAddressEnabled: event.data.IsIpAddressEnabled == null?0: event.data.IsIpAddressEnabled,
      nicknameEnabled: event.data.IsNickNameEnabled == null?0:event.data.IsNickNameEnabled,
      modelID: event.data.modelid,
      equipmentSubTypeID: event.data.equipmentsubtypeid,
      userId: 0,
      ModelId: 0,
      workTypeId: 0,
      resolutionPartId: 0,
      isScheduleActiveFlag: null,
      ScheduleTypeID1: 0,
      ServiceRequestTypeId1: 0,
      ScheduleFrequencyId1: 0,
      PMScheduleId1: 0,
      daysBeforeZero1: null,
      isAlertEnabledFlag1: 0,
      SQACodeId1: 0,
      SQASubCodeId1: 0,
      ScheduleTypeID2: 0,
      ServiceRequestTypeId2: 0,
      ScheduleFrequencyId2: 0,
      PMScheduleId2: 0,
      daysBeforeZero2: null,
      isAlertEnabledFlag2: null,
      SQACodeId2: 0,
      SQASubCodeId2: 0
    };
    this.ngmodelScheduleId_1="";
    this.ngmodelScheduleId_2="";
    this.hideAdd = true;
    this.hideAlerts = false;
    this.hideSave = false;
    this.hideDelete = false;
    this.hideCancel = false;
    event.data.SoftwareVersion
    if (event.data.SoftwareVersion != null) {
      var arrySoftwareVersion = event.data.SoftwareVersion.split(',');
      if (arrySoftwareVersion.length > 0) {
        for (var i = 0; i < arrySoftwareVersion.length; i++) {
          var versonNo = arrySoftwareVersion[i].split('_');
          if (i == 0) {
            this.manageOemMoel.softwareVersion1 = versonNo[0];
            this.manageOemMoel.softwareVersion1VersionNo = versonNo[1];
            this.versionList2 = [];
            for (let c of this.versionList) {
              if (c.value != this.manageOemMoel.softwareVersion1) {
                this.versionList2.push({
                  label: c.label,
                  value: c.value
                });
              }
            }

          }
          if (i == 1) {
            this.manageOemMoel.softwareVersion2 = versonNo[0];
            this.manageOemMoel.softwareVersion2VersionNo = versonNo[1];
            this.versionList3 = [];
            for (let c of this.versionList) {
              if (c.value != this.manageOemMoel.softwareVersion2 && c.value != this.manageOemMoel.softwareVersion1) {
                this.versionList3.push({
                  label: c.label,
                  value: c.value
                });
              }
            }

          }
          if (i == 2) {
            this.manageOemMoel.softwareVersion3 = versonNo[0];
            this.manageOemMoel.softwareVersion3VersionNo = versonNo[1];
          }
        }
      }
    }
    if (event.data.SoftwareVersion == null) {
      this.manageOemMoel.softwareVersion1VersionNo = 0;
      this.manageOemMoel.softwareVersion2VersionNo = 0;
      this.manageOemMoel.softwareVersion3VersionNo = 0;
    }
    this.getModelScheduleParam.ModelId = this.manageOemMoel.modelID;    
    
    this.getModelSchedule(this.getModelScheduleParam);
    if (this.manageOemMoel.equipmentTypeID != null) {
      this.hideSubType = false;
      this.hideAlerts = false;
      this.getEquipmentSubtypes(this.manageOemMoel.equipmentTypeID);
      this.getEquipmentTypeSQACodesParam.equipmentTypeId = this.manageOemMoel.equipmentTypeID;
      this.getEquipmentTypeSQACodes(this.getEquipmentTypeSQACodesParam);
      this.getEquipmentTypeSQACodes2(this.getEquipmentTypeSQACodesParam);

    } else {
      this.hideSubType = true;
      this.hideAlerts = true;
    }
    this.getModelPartsPram.modelId = this.manageOemMoel.modelID;
    this.getModelParts(this.getModelPartsPram);
  }

  public getModelSchedule(GETMODELSCHEDULE: any) {
    if (GETMODELSCHEDULE != null) {
      this._ModelService.getModelSchedule(JSON.stringify({
          GETMODELSCHEDULE
        }))
        .subscribe((getModelScheduleResponse: any) => {
          if (getModelScheduleResponse.maintenance.length > 0) {
            this.hideAlerts = true;
            this.hideSRScheduleAlerts = false;
            this.hideCustomTab = false;
            for (let ModelSchedule of getModelScheduleResponse.maintenance) {
              if (ModelSchedule.ScheduleTypeID == 1) {
                
                //( < HTMLInputElement > document.getElementById('modelScheduleId_1')).value = ModelSchedule.ModelScheduleID;
                this.ngmodelScheduleId_1= ModelSchedule.ModelScheduleID;
                
                this.manageOemMoel.ServiceRequestTypeId1 = ModelSchedule.ServiceRequestTypeID;
                this.manageOemMoel.ScheduleFrequencyId1 = ModelSchedule.ScheduleFrequencyId;
                this.manageOemMoel.ScheduleTypeID1 = ModelSchedule.ScheduleTypeID;
                this.manageOemMoel.isAlertEnabledFlag1 = ModelSchedule.isAlertEnabledFlag;
                this.manageOemMoel.resolutionPartId = ModelSchedule.resolutionPartId;
                this.manageOemMoel.daysBeforeZero1 = ModelSchedule.daysBeforeZero;
                this.manageOemMoel.SQACodeId1 = ModelSchedule.SQACodeId;
                if (this.manageOemMoel.SQACodeId1 > 0) {
                  this.getSqaSubCodesParam.SQACODEID = this.manageOemMoel.SQACodeId1;
                  this.getSqaSubCodes(this.getSqaSubCodesParam);
                }
                this.manageOemMoel.SQASubCodeId1 = ModelSchedule.SQASubCodeId;
                this.manageOemMoel.PMScheduleId1 = ModelSchedule.pmScheduleId;
                this.manageOemMoel.nicknameEnabled = ModelSchedule.IsNickNameEnabled;
                this.manageOemMoel.IPAddressEnabled = ModelSchedule.IsIpAddressEnabled;
              }

              if (ModelSchedule.ScheduleTypeID == 2) {

                //( < HTMLInputElement > document.getElementById('modelScheduleId_2')).value = ModelSchedule.ModelScheduleID;
                this.ngmodelScheduleId_2= ModelSchedule.ModelScheduleID;
                this.manageOemMoel.ServiceRequestTypeId2 = ModelSchedule.ServiceRequestTypeID;
                this.manageOemMoel.ScheduleFrequencyId2 = ModelSchedule.ScheduleFrequencyId;
                this.manageOemMoel.ScheduleTypeID2 = ModelSchedule.ScheduleTypeID;
                this.manageOemMoel.isAlertEnabledFlag2 = ModelSchedule.isAlertEnabledFlag;
                this.manageOemMoel.workTypeId = ModelSchedule.workTypeId;
                this.manageOemMoel.resolutionPartId = ModelSchedule.resolutionPartId;
                this.manageOemMoel.daysBeforeZero2 = ModelSchedule.daysBeforeZero;
                this.manageOemMoel.SQACodeId2 = ModelSchedule.SQACodeId;
                if (this.manageOemMoel.SQACodeId2 > 0) {
                  this.getSqaSubCodesParam2.SQACODEID = this.manageOemMoel.SQACodeId2;
                  this.getSqaSubCodes2(this.getSqaSubCodesParam2);
                }
                this.manageOemMoel.SQASubCodeId2 = ModelSchedule.SQASubCodeId;
                this.manageOemMoel.isScheduleActiveFlag = ModelSchedule.isScheduleActiveFlag;
                this.manageOemMoel.PMScheduleId2 = ModelSchedule.pmScheduleId;
                this.manageOemMoel.nicknameEnabled = ModelSchedule.IsNickNameEnabled;
                this.manageOemMoel.IPAddressEnabled = ModelSchedule.IsIpAddressEnabled;
              }
              let pmScheduleListObj = getModelScheduleResponse.maintenance.filter(a => a.ScheduleTypeID == 2 || a.ScheduleTypeID == 1);
              if (pmScheduleListObj.length > 0) {
                this.showCustom = true;
              }
            }
          } else {
            this.hideCustomTab = true;
            this.hideSRScheduleAlerts = true;
          }

        }, (respose: Response) => {

        });
    }

  }
  onRowSelectMnfr(event: any, template ? : any) {
    this.manageOemMoelmnf = {
      manufacturerNameMnf: event.data.ManufacturerName,
      manufacturerIDMnf: event.data.ManufacturerID,
      iProcVendorId: event.data.iProcVendorID,
      isActiveFlag: event.data.isActiveFlag,
      warrantyDefaultEquipment: event.data.WarrantyDefaultEquipment,
      warrantyDefaultParts: event.data.WarrantyDefaultParts,
      equipmentWarrantyID: 0,
      partWarrantyID: 0,
      userId: 0,
      CreatedBy: '',
      DateCreated: '',
      ModifiedBy: '',
      DateModified: ''

    };
    this.hideAddMnfr = true;
    this.hideSaveMnfr = false;
    this.hideDeleteMnfr = false;
    this.hideCancelMnfr = false;
  }
  ViewAll(event) {
    this.getModelsParam.manufacturerId = 0;
    this.getModels(this.getModelsParam);
  }
  AddAlerts(event) {
    this.showCustom = false;    
    this.hideAlerts = true;
    this.hideSRScheduleAlerts = false;
  }
  getServiceRequestTypes(GETSERVICEREQUESTTYPES: any) {
    this._ServiceRequestService.getServiceRequestTypes(JSON.stringify({
        GETSERVICEREQUESTTYPES
      }))
      .subscribe((allServiceRequestTypesResponse: any) => {
        if (allServiceRequestTypesResponse.length > 0)
          this.serviceRequestTypesList = [];
        for (let c of allServiceRequestTypesResponse) {
          this.serviceRequestTypesList.push({
            label: c.serviceRequestTypeAbbr,
            value: c.serviceRequestTypeId
          });;
        }

      }, (respose: Response) => {
        this.serviceRequestTypesList = [];
      });

  }
  getPMScheduleForOEM(GETPMSCHEDULEFOROEM: any) {
    this._ModelService.getPMScheduleForOEM(JSON.stringify({
        GETPMSCHEDULEFOROEM
      }))
      .subscribe((allPMScheduleForOEMResponse: any) => {

        if (allPMScheduleForOEMResponse.pmSchedule.length > 0)
          this.PMScheduleForOEMList = [];
        for (let c of allPMScheduleForOEMResponse.pmSchedule) {

          this.PMScheduleForOEMList.push({
            label: c.pmScheduleDescription,
            value: c.pmScheduleID
          });;
        }

      }, (respose: Response) => {
        this.PMScheduleForOEMList = [];
      });

  }

  getEquipmentTypeSQACodes(GETEQUIPMENTTYPESQACODES: any) {
    this._SqacodeService.getEquipmentTypeSQACodes(JSON.stringify({
        GETEQUIPMENTTYPESQACODES
      }))
      .subscribe((allEquipmentTypeSQACodesResponse: any) => {
        if (allEquipmentTypeSQACodesResponse.length > 0)
          this.EquipmentTypeSQACodesList = [];
        for (let c of allEquipmentTypeSQACodesResponse) {
          this.EquipmentTypeSQACodesList.push({
            label: c.SQADescription,
            value: c.SQACodeId
          });;
        }
      }, (respose: Response) => {
        this.EquipmentTypeSQACodesList = [];
      });

  }
  getEquipmentTypeSQACodes2(GETEQUIPMENTTYPESQACODES: any) {
    this._SqacodeService.getEquipmentTypeSQACodes(JSON.stringify({
        GETEQUIPMENTTYPESQACODES
      }))
      .subscribe((allEquipmentTypeSQACodesResponse: any) => {
        if (allEquipmentTypeSQACodesResponse.length > 0)
          this.EquipmentTypeSQACodesList2 = [];
        for (let c of allEquipmentTypeSQACodesResponse) {
          this.EquipmentTypeSQACodesList2.push({
            label: c.SQADescription,
            value: c.SQACodeId
          });;
        }
      }, (respose: Response) => {
        this.EquipmentTypeSQACodesList2 = [];
      });

  }
  getSqaSubCodes(GETSQASUBCODES: any) {
    this._sqasubcodeService.getSqaSubCodes(JSON.stringify({
        GETSQASUBCODES
      }))
      .subscribe((allSqaSubCodesResponse: any) => {
        if (allSqaSubCodesResponse.length > 0) {
          this.SqaSubCodesList = [];
          for (let c of allSqaSubCodesResponse) {
            this.SqaSubCodesList.push({
              label: c.sqaSubDescription,
              value: c.sqaSubCodeId
            });
          }
          this.SQASubCodeDisabled = false;
        } else {
          this.SQASubCodeDisabled = true;
        }

      }, (respose: Response) => {
        this.SqaSubCodesList = [];
      });
  }
  getSqaSubCodes2(GETSQASUBCODES: any) {
    this._sqasubcodeService.getSqaSubCodes(JSON.stringify({
        GETSQASUBCODES
      }))
      .subscribe((allSqaSubCodesResponse: any) => {
        if (allSqaSubCodesResponse.length > 0) {
          this.SqaSubCodesList2 = [];
          for (let c of allSqaSubCodesResponse) {
            this.SqaSubCodesList2.push({
              label: c.sqaSubDescription,
              value: c.sqaSubCodeId
            });

          }
          this.SQASubCodeDisabled2 = false;
        } else {
          this.SQASubCodeDisabled2 = true
        }

      }, (respose: Response) => {
        this.SqaSubCodesList2 = [];
      });
  }
  getScheduleFrequency(GETSCHEDULEFREQUENCY: any) {
    this._ModelService.getScheduleFrequency(JSON.stringify({
        GETSCHEDULEFREQUENCY
      }))
      .subscribe((allScheduleFrequencyResponse: any) => {
        if (allScheduleFrequencyResponse.frequency.length > 0)
          this.ScheduleFrequencyList = [];
        for (let c of allScheduleFrequencyResponse.frequency) {
          this.ScheduleFrequencyList.push({
            label: c.scheduleFrequencyDescription,
            value: c.scheduleFrequencyId
          });;
        }

      }, (respose: Response) => {
        this.ScheduleFrequencyList = [];
      });
  }
  getWorkTypes(GETWORKTYPES: any) {
    this._WorktypeService.getWorkTypes(JSON.stringify({
        GETWORKTYPES
      }))
      .subscribe((allWorkTypesResponse: any) => {
        if (allWorkTypesResponse.length > 0)
          this.WorkTypesList = [];
        for (let c of allWorkTypesResponse) {
          this.WorkTypesList.push({
            label: c.WorkTypeDescription,
            value: c.WorkTypeId
          });;
        }

      }, (respose: Response) => {
        this.WorkTypesList = [];
      });

  }
  getModelParts(GETMODELPARTS: any) {
    this._PartsService.getModelParts(JSON.stringify({
        GETMODELPARTS
      }))
      .subscribe((allModelPartsResponse: any) => {
        if (allModelPartsResponse.parts.length > 0)
          this.ModelPartsListEnabled = true;
        this.ModelPartsList = [];
        for (let c of allModelPartsResponse.parts) {
          this.ModelPartsList.push({
            label: c.partDescription,
            value: c.partId
          });
        }
      }, (respose: Response) => {
        this.WorkTypesList = [];
      });

  }
  LoadSQASubCode(event) {
    if (this.manageOemMoel.SQACodeId1 != null) {
      this.getSqaSubCodesParam.SQACODEID = this.manageOemMoel.SQACodeId1;
      this.getSqaSubCodes(this.getSqaSubCodesParam);
    }

  }
  LoadSQASubCode2(event) {
    if (this.manageOemMoel.SQACodeId2 != null) {
      this.getSqaSubCodesParam2.SQACODEID = this.manageOemMoel.SQACodeId2;
      this.getSqaSubCodes2(this.getSqaSubCodesParam2);
    }

  }
  showModalDialog() {
    ( < HTMLInputElement > document.getElementById('ErrorOverLay')).style.height = "100%";
  }
  closeModalDialog() {
    ( < HTMLInputElement > document.getElementById('ErrorOverLay')).style.height = "0%";
  }
  SetVersion1Selected() {
    if (this.manageOemMoel.softwareVersion1 != null) {
      if (this.manageOemMoel.softwareVersion1.length > 0) {
        this.manageOemMoel.softwareVersion1VersionNo = 1;
      }

      this.versionList2 = [];
      for (let c of this.versionList) {
        if (c.value != this.manageOemMoel.softwareVersion1) {
          this.versionList2.push({
            label: c.label,
            value: c.value
          });
        }
      }

    }
    if (this.manageOemMoel.softwareVersion1 == null) {
      this.manageOemMoel.softwareVersion1VersionNo = null;
    }

  }
  softwareVersion1VersionNo() {
    if (this.manageOemMoel.softwareVersion1VersionNo != null && (this.manageOemMoel.softwareVersion1VersionNo != undefined)) {
      if (this.manageOemMoel.softwareVersion1VersionNo == 0) {
        this.manageOemMoel.softwareVersion1 = null;
        this.manageOemMoel.softwareVersion2 = null;
        this.manageOemMoel.softwareVersion3 = null;
        this.manageOemMoel.softwareVersion1VersionNo = 0;
        this.manageOemMoel.softwareVersion2VersionNo = 0;
        this.manageOemMoel.softwareVersion3VersionNo = 0;
        this.versionList2 = [];
        this.versionList3 = [];

      }
    }

  }
  softwareVersion2VersionNo() {
    if (this.manageOemMoel.softwareVersion2VersionNo != null && (this.manageOemMoel.softwareVersion2VersionNo != undefined)) {
      if (this.manageOemMoel.softwareVersion2VersionNo == 0) {
        this.manageOemMoel.softwareVersion2 = null;
        this.manageOemMoel.softwareVersion3VersionNo = 0;

        this.manageOemMoel.softwareVersion3 = null;
        this.manageOemMoel.softwareVersion3VersionNo = 0;

      }
    }

  }
  SetVersion2Selected() {
    if (this.manageOemMoel.softwareVersion2 != null) {
      if (this.manageOemMoel.softwareVersion2.length > 0) {
        this.manageOemMoel.softwareVersion2VersionNo = 1;
      }
      this.versionList3 = [];
      for (let c of this.versionList) {
        if (c.value != this.manageOemMoel.softwareVersion2 && c.value != this.manageOemMoel.softwareVersion1) {
          this.versionList3.push({
            label: c.label,
            value: c.value
          });
        }
      }
    }
    if (this.manageOemMoel.softwareVersion2 == null) {
      this.manageOemMoel.softwareVersion2VersionNo = null;
    }
  }
  SetVersion3Selected() {
    if (this.manageOemMoel.softwareVersion3 != null) {
      if (this.manageOemMoel.softwareVersion3.length > 0) {
        this.manageOemMoel.softwareVersion3VersionNo = 1;
      }
    }
    if (this.manageOemMoel.softwareVersion3 == null) {
      this.manageOemMoel.softwareVersion3VersionNo = null;
    }
  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }
}
